import { LinearProgress } from '@mui/material';
import styled from '@mui/system/styled';

import { useAppSelector } from '../hooks';
import { selectIsLoading } from '../slice';

export const MainLayoutLoader = () => {
    const isLoading = useAppSelector(selectIsLoading);

    return isLoading ? (
        <GlobalLoaderRoot>
            <LinearProgress color="primary" />
        </GlobalLoaderRoot>
    ) : null;
};

const GlobalLoaderRoot = styled('div')(
    ({ theme }) => ({
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 2001,
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    })
);
